import { render, staticRenderFns } from "./sites.vue?vue&type=template&id=f1b0a248&"
import script from "./sites.vue?vue&type=script&lang=js&"
export * from "./sites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports